var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import model from '../base.model';
import urls from '../../constants/urls.constant';
import { loginModel } from '../auth/login.model';
import { getServerUrl as settingsGetServerUrl } from '../../device/settings.storage';
import { config } from '../../config/apiConfig';

class pinModel extends model {

    //region init

    static create() {
        return _extends({}, super.create(), {
            description: '',
            permissions: [],
            groups: []
        });
    }

    //endregion

    //region api

    static apiPost(requestMethod, params = {}) {
        var _this = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this.mapToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const url = urls.auth.registerPin(urlParams);
            const serverUrl = yield settingsGetServerUrl();

            return requestMethod(serverUrl, url, serverModel.payload, authToken);
        })();
    }

    //endregion

    //region mapper

    static mapToClient(serverModel) {
        const toClient_SubPermissons = ({ resource, read, write }) => {
            return { resource, read, write };
        };
        const toClient_Permissons = ({ resource, read, write, sub_permissions }) => {
            return {
                resource,
                read,
                write,
                subPermissions: sub_permissions.map(sp => toClient_SubPermissons(sp))
            };
        };

        const permissions = serverModel.permissions.map(permission => toClient_Permissons(permission));

        const {
            pin,
            description,
            last_modified,
            expiration,
            groups
        } = serverModel;

        return {
            pin: pin ? pin.toString() : '',
            description,
            last_modified,
            expiration,
            permissions,
            groups
        };
    }

    static mapToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {};
        }

        const { email, password } = clientModel;

        const device_name = "myLab Thermometer V1.1.08 5478AA2C00000102";
        const description = "demo user";
        const sub_permissions = [{ "resource": device_name, "read": true, "write": true }];
        const permissions = [{
            "resource": "device_access",
            "read": false,
            "write": false,
            "sub_permissions": sub_permissions
        }];
        const groups = [];
        const user = { description, permissions, groups };

        return {
            urlParams: {},
            authParams: {
                email,
                password
            },
            payload: {
                username: email
            }
        };
    }

    //endregion

    //region reducer

    // static reduceRequest(state, action) {
    //     return {
    //         ...super.reduceRequest(state, action),
    //         [registerModel.MODEL_NAME]: registerModel.create(),
    //     };
    // };

    static reduceGet(state, action) {
        const { modelClient } = action.payload;
        return {
            [pinModel.MODEL_NAME]: _extends({}, modelClient, {
                isLoading: false
            })
            // [registerModel.MODEL_NAME]: registerModel.create(),
        };
    }
}

pinModel.MODEL_NAME = 'pinModel';
pinModel.TYPE_REQUEST = 'REQUEST_REGISTER_PIN';
pinModel.TYPE_FROM_SERVER = 'GET_REGISTER_PIN';
pinModel.TYPE_CLEAR = 'CLEAR_REGISTER_PIN';
export { pinModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/auth/pin.model.js